import { memo } from 'react'

import dynamic from 'next/dynamic'

import { Layout } from 'modules/layout'

import Hero from './hero'

const Benefits = dynamic(() => import('./benefits'))
const CodeConduct = dynamic(() => import('./code-conduct'))
const Guidelines = dynamic(() => import('./guidelines'))
const WhistleblowingChannel = dynamic(() => import('./whistleblowing-channel'))
const WhistleblowingFlow = dynamic(() => import('./whistleblowing-flow'))
const Relationship = dynamic(() => import('./relationship'))
const Privacy = dynamic(() => import('./privacy'))
const Esg = dynamic(() => import('./esg'))
const Leadership = dynamic(() => import('./leadership'))
const Legislation = dynamic(() => import('./legislation'))
const SeeMore = dynamic(() => import('./see-more'))

const IntegrityProgram = memo(() => (
  <Layout>
    <Hero />
    <Benefits />
    <CodeConduct />
    <Guidelines />
    <WhistleblowingChannel />
    <WhistleblowingFlow />
    <Relationship />
    <Privacy />
    <Esg />
    <Leadership />
    <Legislation />
    <SeeMore />
  </Layout>
))

IntegrityProgram.displayName = 'IntegrityProgram'

export default IntegrityProgram
